import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Import theme styles
import '@/assets/theme.css'

// Import token expiration initialization
import { initializeTokenExpiration } from '@/api/auth.js'

// Import base components for global registration
import BaseButton from '@/components/base/BaseButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseCard from '@/components/base/BaseCard.vue'
import BaseModal from '@/components/base/BaseModal.vue'
import BaseTable from '@/components/base/BaseTable.vue'
import BaseNotification from '@/components/base/BaseNotification.vue'

// Create Vue app
const app = createApp(App)

// Register base components globally
app.component('BaseButton', BaseButton)
app.component('BaseInput', BaseInput)
app.component('BaseCard', BaseCard)
app.component('BaseModal', BaseModal)
app.component('BaseTable', BaseTable)
app.component('BaseNotification', BaseNotification)

// Initialize token expiration checking
initializeTokenExpiration()

// Use router and mount app
app.use(router).mount('#app')
